import React from "react";
import Loading from "../../../common/components/Loading";
import Pagination from "../../../common/components/Pagination";
import { Flex } from "../../../common/styles/commonStyles";
import useNoteReportList from "./NoteReportList.hook";
import ReportCard from "./ReportCard";

function NoteReportList() {
  const {
    models: { loading, data, offset, totalPageCount },
    operations: { onPageChange },
  } = useNoteReportList();

  return (
    <>
      {loading && <Loading />}
      {!loading && (
        <Flex
          flexWrap="wrap"
          alignItems="stretch"
          gap={4}
          width="100%"
          justifyContent="flex-start"
        >
          {data?.map((report) => (
            <ReportCard key={report?.id} report={report} />
          ))}
        </Flex>
      )}

      <Pagination
        forcePage={offset}
        pageCount={totalPageCount}
        pageRangeDisplayed={5}
        previousLabel="Prev"
        nextLabel="Next"
        onPageChange={onPageChange}
      />
    </>
  );
}

export default NoteReportList;
